import React from "react"
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './privacyPolicy.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
// -------------------------------------------------

/**
 * Privacy Policy Component
 * Displays the company's privacy policy with:
 * - Hero section with gradient background
 * - Styled content sections with icons
 * - Last updated date
 */
const PrivacyPolicy = () => {

  // Policy sections with icons
  const sections = [
    {
      icon: 'fa-solid fa-database',
      title: 'Information We Collect',
      content: 'We collect information you provide directly to us, such as your name, email address, phone number, and travel preferences when you create an account, make a booking, or contact us for support.'
    },
    {
      icon: 'fa-solid fa-shield-halved',
      title: 'How We Use Your Information',
      content: 'We use the information we collect to process your bookings, communicate with you about your travel plans, provide customer support, and improve our services. We may also use your information to send you promotional communications with your consent.'
    },
    {
      icon: 'fa-solid fa-share-nodes',
      title: 'Information Sharing',
      content: 'We share your information with travel service providers (hotels, airlines, tour operators) to complete your bookings. We do not sell your personal information to third parties for marketing purposes.'
    },
    {
      icon: 'fa-solid fa-lock',
      title: 'Data Security',
      content: 'We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.'
    },
    {
      icon: 'fa-solid fa-cookie',
      title: 'Cookies & Tracking',
      content: 'We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and personalize content. You can manage your cookie preferences through your browser settings.'
    },
    {
      icon: 'fa-solid fa-user-check',
      title: 'Your Rights',
      content: 'You have the right to access, correct, or delete your personal information. You can also opt-out of marketing communications at any time by clicking the unsubscribe link in our emails.'
    }
  ];

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className='policy-hero'>
        <div className='policy-hero-overlay'></div>
        <div className='container policy-hero-content'>
          <div className='policy-icon'>
            <i className='fa-solid fa-shield-halved'></i>
          </div>
          <h1>Privacy Policy</h1>
          <p>Your privacy is important to us</p>
        </div>
      </section>

      {/* Last Updated */}
      <section className='policy-updated'>
        <div className='container'>
          <span className='update-badge'>
            <i className='fa-solid fa-calendar-check me-2'></i>
            Last Updated: December 2024
          </span>
        </div>
      </section>

      {/* Policy Content */}
      <section className='policy-content'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-10'>
              {/* Introduction */}
              <div className='policy-intro'>
                <p>
                  At Travel Pradesh, we are committed to protecting your privacy. This Privacy Policy explains how we
                  collect, use, disclose, and safeguard your information when you visit our website or use our services.
                  Please read this policy carefully to understand our practices regarding your personal data.
                </p>
              </div>

              {/* Policy Sections */}
              {sections.map((section, index) => (
                <div key={index} className='policy-section'>
                  <div className='section-icon'>
                    <i className={section.icon}></i>
                  </div>
                  <div className='section-content'>
                    <h3>{section.title}</h3>
                    <p>{section.content}</p>
                  </div>
                </div>
              ))}

              {/* Contact Section */}
              <div className='policy-contact'>
                <h3><i className='fa-solid fa-envelope me-2'></i>Contact Us</h3>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                </p>
                <a href='mailto:privacy@travelpradesh.com' className='contact-email'>
                  privacy@travelpradesh.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

export default PrivacyPolicy
